<!-- 联络我们 -->
<template>
    <div>
      <div class="header_img"></div>
      <div class="need_submitted">
         <div class="header_title">快速提交你的需求</div>
         <div class="submitted_form">
           <div class="one_from">
             <div class="input_name"><el-input placeholder="请输入您的姓名" v-model="form.name" /></div>
             <div class="input_phone"><el-input placeholder="请输入您的手机号" v-model="form.phone" /></div>
           </div>
           <div class="two_from">
             <div class="input_need_content">
               <el-input type="textarea" :rows="8" placeholder="请输入您的需求" v-model="form.needContent"> </el-input>
             </div>
           </div>
           <div class="three_from">
             <div class="input_code"><el-input placeholder="请输入验证码" v-model="form.code" /></div>
             <div class="input_code_img"><img :src="verfyImg?verfyImg:process.env.BASE_URL+'/customer/getVerifyCode'" @click="changVertify" /></div>
             <div class="btn_submit"><el-button type="primary">发布您的需求</el-button></div>
           </div>
         </div>
         <div class="contact_info">
           <div class="header_title">联系我们</div>
           <div class="info_content">
              <div class="content_detail">
                <div class="left_item">
                  <div class="left_item_one">
                    <div class="title">邮箱：</div>
                    <div class="content_info">584595327@qq.com</div>
                  </div>
                  <div class="left_item_one right_margin">
                    <div class="title">电话：</div>
                    <div class="content_info">13670781026</div>
                  </div>
                </div>
                <div class="right_item">
                  <img src="../../assets/images/index/weixin.png" />
                </div>
              </div>
           </div>
         </div>
      </div>
    </div>
</template>

<script>
import { concatMeta } from '@/config/metaJson.js'

export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {},
  data () {
    return {
      pageTitle: '广州市优科易网络科技有限公司-聯絡我們',
      metaName:'广州市优科易网络科技有限公司-聯絡我們',
      metaContent:'广州市优科易网络科技有限公司-聯絡我們',
      keyword:'广州市优科易网络科技有限公司,优科易，网络科技,优科易网络科技',
      description:'广州市优科易网络科技有限公司' ,   
      form: {
        code: '',
        name: '',
        phone: '',
        needContent:'',
      },
      concatArr: [
        {
          text: 'location',
          icon_src: require('@/assets/images/concat/home.png')
        },
        {
          text: '(+86) 136 7078 1026',
          icon_src: require('@/assets/images/concat/phone.png')
        },
        {
          text: '584595327@qq.com',
          icon_src: require('@/assets/images/concat/email.png')
        },
        {
          text: '(+86) 136 7078 1026',
          icon_src: require('@/assets/images/concat/fax.png')
        },
      ],  
      verfyImg: process.env.BASE_URL + "/customer/getVerifyCode",//图片验证码地址
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou youkeyi Network Technology Co., Ltd',
        'zh-TCC': '廣州市優科易網絡科技有限公司',
        'zh-CN': '广州市优科易网络科技有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {
    onSubmit () {

    },
    
    changVertify() {
      this.verfyImg = process.env.BASE_URL + "/customer/getVerifyCode?num=" + Math.random();
    },
  },
  created () {

  },
  mounted () {
  },
}
</script>
<style lang='scss' scoped>
.header_img{
  width: 100%;
  height: 300px;
  padding-top: 96px;
  padding-left: 31px;
  background: url('~@/assets/images/concat/concat_header.png') no-repeat;
  background-size: 100% 100%;
  text-align: left;
}
.need_submitted{
  margin-top: 100px;
  text-align: center;
  .header_title{
    font-family: MicrosoftYaHei-Bold;
    font-size: 35px;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 3px;
    color: #333333;
    margin-bottom:70px;
   
  }
   .submitted_form{
     width: 100%;
      text-align: center;
      .one_from{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-bottom:20px;
        padding-left:20px;
        padding-right: 20px;
        .input_name{
          width: 460px;
          // height: 140px;
        }
        .input_phone{
          width:460px;
          margin-left:22px;
          height: 40px;
        }
      }
      .two_from{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding-left:20px;
        padding-right: 20px;
        margin-bottom: 20px;
        .input_need_content{
          width:938px;
        }
      }
      .three_from{
        
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding-left:20px;
        padding-right: 20px;
        margin-bottom: 20px;
        .input_code{
          width:660px;
        }
        .input_code_img{
          width: 120px;
          height: 40px;
          background-color: #ffffff;
          border-top: solid 1px #dddddd;
          border-right: solid 1px #dddddd;
          border-bottom: solid 1px #dddddd;
          display: flex;
          justify-content: center;
          align-items: center;
          
        }
        .btn_submit{
          margin-left:21px;
          height: 40px;
        }
      }
      
    }
}
.contact_info{
  margin-top: 120px;
  width: 100%;
  text-align: center;
  .header_title{
    font-family: MicrosoftYaHei-Bold;
    font-size: 35px;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 3px;
    color: #333333;
    margin-bottom:48px;
  }
  .info_content{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom:157px;
    .content_detail{
      width: 937px;
      height: 150px;
      background: url('~@/assets/images/concat/concat_bottom.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      color:#ffffff;
      flex-direction: row;
      align-items: center;
      padding-left:29px;
      padding-right: 14px;
      .left_item{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        text-align: left;
        .left_item_one{
          display: flex;
          justify-content: left;
          align-items: left;
          flex-direction: column;
          font-size: 14px;
          .title{
            padding-bottom:10px;
          }
          .content_info{

          }
        }
        .right_margin{
          margin-left:54px;
        }
      }
      .right_item{
        width: 120px;
        height: 120px;
        display: flex;
        image{
          width: 120px;
        }
      }
                
              
    }
  }
}
</style>
<style>
.one_from .input_name .el-input__inner{
  height: 45px !important;
  font-size:20px  !important;
}
.one_from .input_phone .el-input__inner{
  height: 45px !important;
  font-size:20px  !important;
}
</style>


// WEBPACK FOOTER //
// src/view/concat/index.vue